import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { BreedinFarms } from '../../components/economicsphere/ui/breedingfarms'; 
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const BreedinFarmsPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Племенные Фермы</title>
            </Helmet>
            <BreedinFarms/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default BreedinFarmsPage
